import React, { useState } from 'react';
import './objetivo.css';

const API_BASE = process.env.REACT_APP_API_BASE;

const Objetivo = ({ onSucesso }) => {
  const [selecionado, setSelecionado] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');

  const opcoes = [
    { label: 'Emagrecer', valor: 'emagrecer', emoji: '🔥' },
    { label: 'Manter peso', valor: 'manter', emoji: '⚖️' },
    { label: 'Ganhar massa', valor: 'ganhar_peso', emoji: '💪' }
  ];

  const handleEnviar = async () => {
    if (!selecionado) return;

    setEnviando(true);
    setErro('');

    try {
      const resposta = await fetch(`${API_BASE}/salvar-etapa.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          campo: 'objetivo',
          valor: selecionado
        })
      });

      const dados = await resposta.json();

      if (dados.status === 'sucesso') {
        onSucesso(); // avança para a próxima etapa do quiz
      } else {
        setErro(dados.mensagem || 'Erro ao salvar. Tente novamente.');
      }
    } catch (error) {
      setErro('Erro de conexão com o servidor.');
    }

    setEnviando(false);
  };

  return (
    <div className="quiz-etapa">
      <h2 className="quiz-pergunta">Qual é o seu objetivo?</h2>

      <div className="quiz-opcoes">
        {opcoes.map((opcao) => (
          <div
            key={opcao.valor}
            className={`quiz-opcao ${selecionado === opcao.valor ? 'selecionado' : ''}`}
            onClick={() => setSelecionado(opcao.valor)}
          >
            <span className="emoji">{opcao.emoji}</span>
            {opcao.label}
          </div>
        ))}
      </div>

      {erro && <p className="quiz-erro">{erro}</p>}

      <button
        className="quiz-botao"
        onClick={handleEnviar}
        disabled={!selecionado || enviando}
      >
        {enviando ? 'Enviando...' : 'Continuar'}
      </button>
    </div>
  );
};

export default Objetivo;
